module.exports = __webpack_public_path__ + "static/media/adrianRosalesHeadshot19.d623f24d.jpg";